import api from "../service/api";

async function save(body) {
  try {
    const { data } = await api.post(`/api/workflow`, body);
    return data;
  } catch {
    return false;
  }
}

async function getPipeline(id) {
  try {
    const { data } = await api.get(`/api/workflow/${id}`);
    return data;
  } catch {
    return null;
  }
}

async function getAll(id) {
  try {
    const { data } = await api.get(`/api/workflow`);
    return data;
  } catch {
    return [];
  }
}

async function run(body) {
  try {
    const { data } = await api.post(`/api/workflow/run`, body, {
      timeout: 0, // Timeout infinito
    });
    return data;
  } catch {
    return false;
  }
}

export default {
  save,
  getPipeline,
  getAll,
  run,
};
